import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import withDisplayImpression from '../../../decorators/withDisplayImpression';
import { logAnalyticsEvent } from '../../../redux/actions/analyticsLog';
import {
  makePromoteItemBadgeIndex,
  makePromoteItemDataByIdKey,
} from '../../../redux/selectors/promotionalThemesSelector';
import PromoteItem from './PromoteItem';

const mapStateToProps = (_, props) => {
  const { id } = props;
  const selector = createStructuredSelector({
    title: makePromoteItemDataByIdKey(id, 'title', ''),
    images: makePromoteItemDataByIdKey(id, 'image_urls', []),
    url: makePromoteItemDataByIdKey(id, 'url', ''),
    badgeIndex: makePromoteItemBadgeIndex(),
  });

  return state => selector(state);
};

const mapDispatchToProps = {
  logEvent: logAnalyticsEvent,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withDisplayImpression(PromoteItem));
